import {useChangeStore} from '../../change';
import type {GridEditor, Permissions} from '../../../types';
import {breakItUp, getAppendChar, getUpdatedValueData} from '../../../utils';
import {FormActions, FormValues} from '@netx/core-components/Form';

const updateAllValues = async (
	gridEditor: GridEditor,
	changeStore: ReturnType<typeof useChangeStore>,
	initialValues: FormValues[],
	values: FormValues,
	permissions: Permissions,
	actions: FormActions = {},
	setProgress?: (progress: number) => void,
) => {
	if (process.env.NODE_ENV === 'development') {
		console.time('set-values/all');
	}

	const {round} = Math;

	const updatingFields = Object.keys(values);

	const data = gridEditor.behavior.dataModel.dataSource.data;
	const columns = gridEditor.behavior.columns;
	const sortIndex = gridEditor.behavior.dataModel.sortIndex;

	const updatingColumnObjects = columns.filter((column) =>
		updatingFields.includes(column.name),
	);
	const updatingFieldCount = updatingColumnObjects.length;

	const appendChar = getAppendChar();
	const size = data.length;

	const amount = size <= 10 ? 1 : 10;
	await breakItUp(
		{
			amount,
			size,
		},
		(index) => {
			setProgress && setProgress(round(((index + 1) / size) * 100));

			const realIndex = sortIndex.indexOf(index);
			const rowData = data[realIndex];
			if (!rowData) return;

			const {assetId} = rowData;
			const perms = permissions[assetId];

			for (let x = 0; x < updatingFieldCount; x++) {
				const column = updatingColumnObjects[x];
				if (!column) continue;
				const {name} = column;

				if (perms && perms.includes(name)) continue;

				const valueData = getUpdatedValueData(
					assetId,
					values,
					rowData,
					initialValues,
					column,
					actions,
					appendChar,
				);

				if (!valueData) continue;

				valueData.changed
					? changeStore.add(assetId, name)
					: changeStore.remove(assetId, name);

				rowData[name] = valueData.value;
			}
		},
	);

	gridEditor.repaint();
	gridEditor.takeFocus();

	setProgress && setProgress(100);

	if (process.env.NODE_ENV === 'development') {
		console.timeEnd('set-values/all');
	}
};

export default updateAllValues;
